// ** React Imports
import { useContext } from "react";
import { useParams } from "react-router-dom";

// ** Redux
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import NavItemLink from "components/base/NavItemLink";
import Item from "components/layout/Nav/Item";
import Text from "components/typography/Text";

// ** Utils
import pseudoFormat from "utils/pseudoFormat";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

export const UserNavSectionGalleryItem = () => {
	const { login } = useParams();

	const galleryItemsCount = useSelector(
		(state) => state.userProfileMain.statistics.userGallery
	);

	const { isPhone } = useContext(deviceTypeContext);

	const { t } = useTranslation();

	// #####################################################

	return (
		<NavItemLink
			container={Item}
			to={`/users/${login.toLowerCase()}/gallery`}
			key={`userGallery`}
			exact={true}
		>
			<Item.Content
				noPad
				flex
				style={{
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{isPhone ? (
					<Block flex column alignCenter>
						<Text>{t(`userProfile:userGallery`)}</Text>
						<Text bold>{pseudoFormat(galleryItemsCount)}</Text>
					</Block>
				) : (
					<>
						{t(`userProfile:userGallery`)}
						<Text bold ml={1}>
							{pseudoFormat(galleryItemsCount)}
						</Text>
					</>
				)}
			</Item.Content>
		</NavItemLink>
	);
};

// #####################################################
